(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-a-latansaa-page"] && !Shopify.designMode) return;
  try {
    
function initLatansaaWorld(){document.querySelectorAll('.lt-world').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const cards=[...root.querySelectorAll('[data-lt-category]')];function select(value){cards.forEach(card=>card.hidden=value!=='all'&&card.dataset.ltCategory!==value);root.querySelectorAll('[data-lt-filter]').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.ltFilter===value)));root.querySelector('.lt-world-count').textContent=cards.filter(card=>!card.hidden).length+' Düfte';}root.querySelectorAll('[data-lt-filter]').forEach(button=>button.addEventListener('click',()=>select(button.dataset.ltFilter)));root.querySelectorAll('[data-lt-family]').forEach(link=>link.addEventListener('click',()=>select(link.dataset.ltFamily)));});}
initLatansaaWorld();document.addEventListener('shopify:section:load',initLatansaaWorld);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-a-rasayel-film"] && !Shopify.designMode) return;
  try {
    
function initRoFilms(){document.querySelectorAll('.ro-film').forEach(function(root){if(root.dataset.ready)return;const video=root.querySelector('video');const button=root.querySelector('.ro-film__sound');if(!video||!button)return;root.dataset.ready='true';const on=root.querySelector('.ro-film__unmute-label').textContent;const off=root.querySelector('.ro-film__mute-label').textContent;function sync(){button.textContent=video.muted?on:off;button.setAttribute('aria-pressed',String(!video.muted));}button.addEventListener('click',function(){video.muted=!video.muted;if(!video.muted){video.currentTime=0;video.play().catch(function(){});}sync();});video.addEventListener('volumechange',sync);sync();});}initRoFilms();document.addEventListener('shopify:section:load',initRoFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["one-a-season-sale-film"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('season-sale-player')) {
  customElements.define('season-sale-player', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const video = this.querySelector('video');
      const button = this.querySelector('button');
      if (!video || !button) return;
      button.addEventListener('click', async () => {
        if (!video.muted) {
          video.muted = true;
          button.textContent = 'Mit Ton abspielen';
          button.setAttribute('aria-pressed', 'false');
          return;
        }
        video.muted = false;
        video.volume = 1;
        video.currentTime = 0;
        try {
          await video.play();
          button.textContent = 'Ton ausschalten';
          button.setAttribute('aria-pressed', 'true');
        } catch {
          video.muted = true;
          button.textContent = 'Mit Ton abspielen';
          button.setAttribute('aria-pressed', 'false');
        }
      }, { signal: this.abortController.signal });
    }
    disconnectedCallback() { this.abortController?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
